<template>
  <div ref="el" class="full-width">
    <Tooltip
      placement="top-start"
      class-name="schedule-board-tooltip prework-event-tooltip"
      style="width: 100%"
      :options="tippyOptions"
    >
      <template #trigger>
        <div
          class="prework-event-content"
          :style="{
            background: event.backgroundColor
          }"
        >
          <!-- Need some inner text to trigger the tooltip  -->
          <!-- Text is hidden via CSS  -->
          Pre-Work Time
        </div>
      </template>
      <template #tooltip>
        <div>
          <div class="d-flex flex-column">
            <div class="tooltip-section">
              <div class="tooltip-row">
                <span>Pre-Work Job #</span>
                <span>{{ details.job_id }}</span>
              </div>
            </div>
            <div class="tooltip-section">
              <div class="tooltip-row">
                <span>Start</span>
                <span>{{ formatDate(event.start, "h:mm A") }}</span>
              </div>
              <div class="tooltip-row">
                <span>End</span>
                <span>{{
                  details.status !== "accepted"
                    ? formatDate(event.end, "h:mm A")
                    : "--"
                }}</span>
              </div>
              <div class="tooltip-row">
                <span>Duration</span>
                <span><minutes-label :minutes="duration"></minutes-label></span>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Tooltip>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { getMinuteDiff } from "@/lib/helpers.js";

import MinutesLabel from "@/components/MinutesLabel.vue";
import Tooltip from "@/components/Tooltip.vue";

export default {
  components: {
    Tooltip,
    MinutesLabel
  },
  props: {
    event: {
      type: Object,
      default: null
    }
  },
  computed: {
    details() {
      return this.event.extendedProps;
    },
    duration() {
      // FIXME: minute based math
      return this.details.status !== "accepted"
        ? getMinuteDiff(this.event.end, this.event.start)
        : null;
    },
    tippyOptions() {
      return {
        interactive: false,
        delay: [0, 0],
        onShow() {
          tippy.hideAll();
        }
      };
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   const el = $(this.$refs.el).closest(".fc-timeline-event-harness")[0];
    //   const top = parseFloat(el.style.top.replace("px", ""));
    //   const Y_OFFSET = 42.5;
    //   el.style.top = top - Y_OFFSET + "px";
    // });
  },
  methods: {
    formatDate(date, format) {
      return moment(date).format(format);
    }
  }
};
</script>

<style lang="scss" scoped>
.prework-event-content {
  min-height: 32px;
  color: transparent;
}
</style>
